import HtmlDisplayer from '@act/react-components/components/HtmlDisplayer';
import { SurveyV2, UserDto } from '@act/shared/data-transfer-objects';
import { useMemo } from 'react';
import { applyMustacheTemplate } from '@act/shared/utilities';
import { timeFormatter } from '@act/shared/utilities';

export interface SurveyTemplateParserProps {
  template: string;
  member: UserDto;
  assignedSurvey: SurveyV2.AssignedSurveyDto;
}

const getResponseDisplayText = (
  question: SurveyV2.QuestionDto,
  response: SurveyV2.QuestionResponseDto
): string => {
  if (!response) {
    return '???';
  }

  if (question.type === 'date') {
    return timeFormatter.epochToShortDate(
      Date.parse(response.textResponse.replace('-', '/')),
      true
    );
  }
  if (
    question.type === 'select' ||
    question.type === 'multiselect' ||
    question.type === 'radio' ||
    question.type === 'checkbox'
  ) {
    return response.selectedOptionIds
      .map(id => {
        return question.options.find(option => option.id === id).text;
      })
      .join(', ');
  }
  return response.textResponse;
};

function generateQuestionMap(assignedSurvey: SurveyV2.AssignedSurveyDto): {
  [key: string]: string;
} {
  // Simplified version for Storybook - just map questions to responses directly
  const questionMap: { [key: string]: string } = {};

  if (assignedSurvey.questions && assignedSurvey.questionResponses) {
    assignedSurvey.questions.forEach(question => {
      const response = assignedSurvey.questionResponses.find(
        r => r.questionId === question.id
      );
      if (question) {
        questionMap[`question:${question.id}`] = getResponseDisplayText(
          question,
          response
        );
      }
    });
  }

  return questionMap;
}

export const SurveyTemplateParser = ({
  template,
  member,
  assignedSurvey,
}: SurveyTemplateParserProps) => {
  const summary = useMemo(() => {
    return applyMustacheTemplate(template, {
      memberName: `${member?.firstName}`,
      ...generateQuestionMap(assignedSurvey),
    });
  }, [template, member, assignedSurvey]);

  return <HtmlDisplayer innerHtml={summary} />;
};
